import { all, takeEvery } from 'redux-saga/effects';

import { FETCH } from './actions';
import { apiCall, Mappings } from '../../lib/LeanLinkService';
import { success, failure } from '../../lib/Actions/factory';
import * as normalizers from '../Entity/normalizers';

function* fetchRequested({ payload: { url, fetchUrl, isInfinitePagination } }) {
  yield apiCall(
    Mappings.get({ url: fetchUrl || url }),
    data => success(FETCH, { url, fetchUrl, isInfinitePagination })(normalizers.entity(data)),
    failure(FETCH, { url, fetchUrl }),
  );
}

export default function* defaultSaga() {
  yield all([
    takeEvery(FETCH.REQUEST, fetchRequested),
  ]);
}
